import { Float, isFloatZero } from "widgets/utils";

/**
 * Replace the number by a valid equivalent number.
 * Some valid finite numbers are not storable in Oracle or not parse-able by Java when read back.
 *   * if x is not a finite number                         => replace with null
 *   * numbers close to zero: there is a gap from 0..1e-45 => replace with zero
 *   * numbers outside the range of +-Float.MAX_VALUE.     => +Float.MAX_VALUE or -Float.MAX_VALUE
 *  @param x The number to normalize for storage
 *  @return the normalized number or undefined
 */
function normalizeForOracle(x: number | string): number {
  // Some valid finite numbers are not storable in Oracle or not parse-able by Java when read back.
  //   * numbers close to zero: there is a gap from 1e-45..0
  //   * numbers outside the range of +-Float.MAX_VALUE.
  const n = Number(x);

  if ((x as string) === "" || x === null || !isFinite(n)) {
    return undefined;
  }

  return isFloatZero(n)
    ? 0 // 'close to zero' is zero
    : n < -Float.MAX_VALUE
      ? -Float.MAX_VALUE
      : Float.MAX_VALUE < n
        ? Float.MAX_VALUE
        : n; // the original value passes
}

export { normalizeForOracle };
